import React, { useState, useEffect, lazy } from "react";
import { Elements } from "@stripe/react-stripe-js";
/* import FormStripe from "../FormStripe"; */

import Spinner from "../../Spinner";
import colores from "../../helpers/colores";
import getPriceCard from "../../helpers/getPriceCard";

import axios from "axios";
const FormStripe = lazy(() => import("../FormStripe"));

const PagoCompleto = ({
    pedido,
    formaPago,
    setFormaPago,
    stripePromise,
    comprobantePreview,
    handleComprobante,
    handlePagoComprobante,
    pagoCompleto,
    setPagoCompleto,
    paying,
}) => {
    const [fechaMinima, setFechaMinima] = useState(false);
    const date_hoy = new Date();
    const date_fecha_inicio = new Date(
        `${pedido?.fecha_inicio.split("/")[1]}/${
            pedido?.fecha_inicio.split("/")[0]
        }/${pedido?.fecha_inicio.split("/")[2]}`
    );

    const diffTime = Math.abs(date_hoy.getTime() - date_fecha_inicio.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    useEffect(() => {
        if (diffDays <= 7) {
            setFechaMinima(true);
        } else {
            setFechaMinima(true);
        }
    }, []);

    const postCuotealo = async () => {
        const json = await axios.post(
            `${process.env.REACT_APP_PROXY}/pagoCuotealo/pago`,
            {
                id: pedido.id,
                tipo_pedido: "Casa", // Enviando `pedido.id` en el cuerpo de la solicitud
            }
        );

        let jsonData = json.data;

        jsonData = JSON.stringify(jsonData);

        const form = document.createElement("form");
        form.method = "POST";
        //form.action = "https://wapceu2pxtid01.azurewebsites.net/inicio"; // Ambiente de desarrollo
        form.action = "https://www.cuotealo.viabcp.com/inicio"; // Ambiente de produccion

        const hiddenField = document.createElement("input");
        hiddenField.type = "hidden";
        hiddenField.name = "data";
        hiddenField.value = jsonData; // Usar la variable jsonData aquí

        form.appendChild(hiddenField);

        document.body.appendChild(form);
        form.submit();
    };
    return (
        <div>
            <h1
                className={`mt-20 text-[${colores.primario}] text-2xl font-semibold`}
            >
                Tu pedido
            </h1>
            <div
                className={`text-[${colores.primario}] font-semibold text-base md:grid md:grid-cols-[50%_50%] flex flex-col-reverse`}
            >
                <div className="p-10">
                    {(pedido.estado === "Pendiente de pago" ||
                        pedido.estado === "Pago parcial") && (
                        <div className="mb-10">
                            <div className="p-3 border-t-2 border-gray-600 rounded-t-lg border-x-2">
                                <input
                                    type="radio"
                                    name="tipo_pago"
                                    className="mr-2 outline-none cursor-pointer"
                                    checked={
                                        pagoCompleto === "pago_completo"
                                            ? "checked"
                                            : ""
                                    }
                                    onChange={(e) => {
                                        setPagoCompleto("pago_completo");
                                    }}
                                />
                                Pago Único:{" "}
                                <p className="text-gray-500">
                                    Realiza el pago total de tu reserva.
                                </p>
                            </div>
                            <div className="p-3 border-2 border-gray-600 rounded-b-lg">
                                {pedido.pagos.segundo_pago.must_pay === true &&
                                    fechaMinima && (
                                        <>
                                            <input
                                                type="radio"
                                                name="tipo_pago"
                                                className="mr-2 outline-none cursor-pointer"
                                                checked={
                                                    pagoCompleto ===
                                                    "pago_parcial"
                                                        ? "checked"
                                                        : ""
                                                }
                                                onChange={(e) => {
                                                    setPagoCompleto(
                                                        "pago_parcial"
                                                    );
                                                }}
                                            />
                                            Pago una parte y otra mas adelante:{" "}
                                            <p className="p-1 text-gray-500">
                                                {" "}
                                                Realiza ahora el pago de la
                                                mitad del aquiler que representa{" "}
                                                {formaPago === "stripe"
                                                    ? (
                                                          pedido?.costo_total_alquiler /
                                                              2 +
                                                          getPriceCard(
                                                              pedido?.costo_total_alquiler /
                                                                  2
                                                          )
                                                      ).toFixed(2)
                                                    : (
                                                          pedido?.costo_total_alquiler /
                                                          2
                                                      ).toFixed(2)}{" "}
                                                {pedido?.tipo_moneda}, y 7 días
                                                antes del check in (
                                                {
                                                    pedido?.fecha_inicio.split(
                                                        "T"
                                                    )[0]
                                                }
                                                ) realiza el pago pendiente
                                                junto con la garantía y
                                                servicios adicionales.
                                            </p>
                                        </>
                                    )}
                            </div>
                        </div>
                    )}
                    <div
                        className={`rounded-lg border-2 border-gray-600 text-[${colores.primario}] p-5 text-xl`}
                    >
                        <h1>Elige tu metodo de pago</h1>
                        <hr className="my-5 border-t-2 border-gray-300" />
                        {formaPago === "Stripe" && (
                            <p className="text-lg font-bold">
                                Pago con tarjeta de crédito/débito cuenta con un
                                costo adicional del 5% del monto a pagar.
                            </p>
                        )}
                        <select
                            onChange={(e) => {
                                setFormaPago(e.target.value);
                            }}
                            value={formaPago}
                            className="bg-slate-100 mt-7 p-3 max-w-[500px] w-full border-gray-400 border rounded-md"
                        >
                            <option className="p-10" value="stripe">
                                Tarjeta de crédito o débito
                            </option>
                            <option className="p-10" value="transferencia">
                                Transferencia bancaria
                            </option>
                            <option className="p-10" value="cuotealo">
                                Cuotealo BCP
                            </option>
                        </select>
                        {formaPago === "stripe" && (
                            <Elements stripe={stripePromise}>
                                <div className="flex w-full mt-5">
                                    <FormStripe
                                        tipo_pedido="Casa"
                                        tipo_pago="Pago completo"
                                        costos={{
                                            costo_tarjeta: 0,
                                            costo:
                                                pedido.estado ===
                                                "Pendiente de pago"
                                                    ? pedido.pagos.segundo_pago
                                                          .monto
                                                    : pedido.estado ===
                                                      "Pago parcial"
                                                    ? pedido.pagos.segundo_pago
                                                          .monto
                                                    : null,
                                            metodo: "Stripe",
                                        }}
                                        pedido={pedido}
                                        amount={
                                            pedido.estado ===
                                            "Pendiente de pago"
                                                ? (
                                                      pedido.pagos.segundo_pago
                                                          .monto +
                                                      getPriceCard(
                                                          pedido.pagos
                                                              .segundo_pago
                                                              .monto
                                                      )
                                                  ).toFixed(2)
                                                : pedido.estado ===
                                                  "Pago parcial"
                                                ? (
                                                      pedido.pagos.segundo_pago
                                                          .monto +
                                                      getPriceCard(
                                                          pedido.pagos
                                                              .segundo_pago
                                                              .monto
                                                      )
                                                  ).toFixed(2)
                                                : null
                                        }
                                    />
                                </div>
                            </Elements>
                        )}
                        {formaPago === "transferencia" && (
                            <div>
                                <p className="mt-10 text-base font-bold text-justify">
                                    Realiza tu pago directamente en nuestra
                                    cuenta bancaria. Por favor, usa el número
                                    del pedido como referencia de pago. Tu
                                    pedido no se procesará hasta que se haya
                                    recibido el importe en nuestra cuenta.
                                </p>
                                <div className="w-full mt-4 text-base font-normal bg-white rounded-md">
                                    {pedido.tipo_moneda === "PEN" ? (
                                        <div>
                                            <div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Banco:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        INTERBANK
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Tipo de cuenta:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        CUENTA CORRIENTE
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Cuenta en Soles:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        2003005063122
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        CCI:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        003-200-003005063122-32
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Titular de cuenta:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        BLUSYSTEM S.A.C.
                                                    </p>
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Banco:
                                                    </p>{" "}
                                                    <p className="ml-3">BCP</p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Tipo de cuenta:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        CUENTA CORRIENTE
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Cuenta en Soles:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        194-9928450-0-72
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        CCI:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        00219400992845007297
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Titular de cuenta:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        BLUSYSTEM S.A.C.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Banco:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        INTERBANK
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Tipo de cuenta:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        CUENTA CORRIENTE
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Cuenta en Dólares:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        2003005063130
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        CCI:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        003-200-003005063130-35
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Titular de cuenta:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        20610169750
                                                    </p>
                                                </div>
                                            </div>
                                            <br />

                                            <div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Banco:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        INTERBANK
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Tipo de cuenta:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        CUENTA CORRIENTE
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Cuenta en Dólares:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        194-9915492-1-93
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        CCI:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        00219400991549219398
                                                    </p>
                                                </div>
                                                <div className="flex flex-row">
                                                    <p className="font-bold">
                                                        Titular de cuenta:
                                                    </p>{" "}
                                                    <p className="ml-3">
                                                        20610169750
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <br />
                                    <p className="font-bold">
                                        Numero de pedido: {pedido.id}
                                    </p>
                                </div>
                                <hr className="border-t-2 border-gray-300 my-15" />
                                <h1 className="mt-4 font-normal">
                                    Por favor, adjuntar su comprobante en
                                    formato Imagen
                                </h1>
                                <div className="relative flex mt-4 bg-white border-4 border-dashed rounded-lg w-72 h-72 ">
                                    {comprobantePreview ? (
                                        <div className="w-full h-full rounded-lg ">
                                            <img
                                                className="object-cover w-full h-full rounded-lg"
                                                src={comprobantePreview}
                                                alt="Comprobante de pago"
                                            />
                                        </div>
                                    ) : (
                                        <div className="flex items-center justify-center p-3 ">
                                            <div className="flex flex-col items-center justify-center w-full mx-auto ">
                                                <div className="relative flex flex-col items-center justify-center">
                                                    <span className="mt-2 font-bold text-center ">
                                                        Arrastre el comprobante
                                                    </span>
                                                    o
                                                    <span
                                                        className={`font-normal text-center text-[${colores.secundario}]`}
                                                    >
                                                        Sube la imagen desde tu
                                                        dispositivo
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <input
                                        type="file"
                                        onChange={handleComprobante}
                                        accept="image/*"
                                        className="absolute top-0 left-0 bg-red-200 opacity-0 cursor-pointer w-72 h-72 file:cursor-pointer"
                                    />
                                </div>
                                <button
                                    className={`payButton bg-[${colores.secundario}] active:translate-y-1 w-full max-w-[288px] disabled:bg-slate-400 hover:disabled:bg-slate-400`}
                                    disabled={!formaPago || paying}
                                    onClick={() => handlePagoComprobante()}
                                >
                                    {paying ? <Spinner width={7} /> : "Pagar"}
                                </button>
                            </div>
                        )}
                        {formaPago === "cuotealo" && (
                            <div className="mt-5">
                                <button
                                    onClick={postCuotealo}
                                    className={`p-5 flex justify-between gap-12 items-center rounded-lg border-2 border-[${colores.primario}] shadow-md hover:scale-105 `}
                                >
                                    <div className="font-semibold">
                                        Pago en cuotas
                                    </div>
                                    <svg
                                        width="123"
                                        height="41"
                                        viewBox="0 0 368 127"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <defs>
                                            <path
                                                id="r31jab0cla"
                                                d="M0 0h17.124v18.103H0z"
                                            />
                                            <path
                                                id="a9lnvb9vtc"
                                                d="M0 0h48.97v49.26H0z"
                                            />
                                            <path
                                                id="hlj0gqg7he"
                                                d="M0 0h90v35H0z"
                                            />
                                        </defs>
                                        <g fill="none" fillRule="evenodd">
                                            <g transform="translate(207.404)">
                                                <mask
                                                    id="iwnc2zx30b"
                                                    fill="#fff"
                                                >
                                                    <use xlinkHref="#r31jab0cla" />
                                                </mask>
                                                <path
                                                    d="M16.918 1.393C16.547.533 15.757 0 14.856 0H2.261C1.078 0 .086.97 0 2.234l.007 13.314c-.071 1.037.475 1.966 1.391 2.366.29.127.59.189.884.189.586 0 1.154-.245 1.594-.712L16.466 4.05c.666-.707.844-1.75.452-2.657"
                                                    fill="#DF1995"
                                                    mask="url(#iwnc2zx30b)"
                                                />
                                            </g>
                                            <path
                                                d="M23.102 34.368c2.007 0 3.805.33 5.344.98 1.533.65 2.972 1.693 4.272 3.096 1.107 1.246 2.483 1.876 4.091 1.876.952 0 1.808-.26 2.54-.774 1.54-1.05 2.322-2.395 2.322-3.997 0-1.108-.374-2.08-1.104-2.884-4.61-5.315-10.486-8.01-17.465-8.01-4.587 0-8.77 1.062-12.43 3.156-3.671 2.1-6.568 5.068-8.61 8.822C.03 40.37-1 44.64-1 49.328c0 4.584 1.061 8.801 3.153 12.536 2.097 3.75 5.049 6.728 8.774 8.854 3.718 2.121 7.956 3.197 12.6 3.197 6.372 0 11.77-2.016 16.054-6 .878-.877 1.323-1.895 1.323-3.023 0-1.444-.677-2.747-2.03-3.884-1.924-1.443-4.276-1.286-6.64.457-2.182 1.817-5.112 2.739-8.707 2.739-2.75 0-5.223-.639-7.35-1.898-2.123-1.257-3.798-3.024-4.979-5.252-1.191-2.246-1.795-4.846-1.795-7.726 0-4.527 1.282-8.197 3.81-10.908 2.508-2.69 5.836-4.052 9.89-4.052M91.273 26.402c-.994-.99-2.298-1.492-3.878-1.492-1.519 0-2.805.498-3.821 1.48-1.03.99-1.551 2.298-1.551 3.887v23.984c0 1.825-.5 3.492-1.486 4.955-1 1.486-2.412 2.685-4.197 3.563-1.806.889-3.844 1.34-6.058 1.34-3.795 0-6.864-1.092-9.124-3.245-2.245-2.14-3.383-5.395-3.383-9.674V30.277c0-1.522-.517-2.811-1.537-3.832-1.02-1.018-2.311-1.535-3.836-1.535-1.526 0-2.816.517-3.835 1.535-1.02 1.018-1.536 2.307-1.536 3.832V51.2c0 4.743.929 8.87 2.761 12.267 1.848 3.423 4.451 6.066 7.737 7.856C60.787 73.099 64.505 74 68.579 74c2.956 0 5.777-.525 8.383-1.56a20.42 20.42 0 0 0 5.187-2.984c.21.994.683 1.861 1.41 2.584 1.018 1.018 2.309 1.535 3.836 1.535 1.589 0 2.897-.52 3.89-1.547.983-1.015 1.482-2.3 1.482-3.82V30.278c0-1.519-.465-2.782-1.38-3.756l-.114-.119zM138.257 49.328c0 2.88-.604 5.479-1.797 7.726-1.178 2.227-2.853 3.995-4.977 5.253-2.127 1.258-4.571 1.897-7.266 1.897-2.694 0-5.138-.639-7.265-1.897-2.126-1.26-3.818-3.03-5.026-5.261-1.217-2.246-1.833-4.842-1.833-7.718 0-2.878.617-5.49 1.834-7.765 1.21-2.258 2.9-4.04 5.025-5.298 2.126-1.26 4.57-1.898 7.265-1.898 2.696 0 5.14.639 7.266 1.898 2.12 1.255 3.794 3.035 4.975 5.29 1.194 2.28 1.8 4.895 1.8 7.773m-1.485-21.52c-3.69-2.092-7.915-3.153-12.556-3.153-4.697 0-8.963 1.06-12.68 3.152-3.728 2.1-6.669 5.052-8.739 8.774-2.062 3.71-3.109 7.998-3.109 12.747 0 4.692 1.047 8.952 3.11 12.662 2.07 3.724 5.01 6.676 8.739 8.773 3.714 2.091 7.98 3.152 12.68 3.152 4.698 0 8.951-1.06 12.64-3.153 3.696-2.097 6.62-5.049 8.694-8.772 2.062-3.712 3.109-7.972 3.109-12.662 0-4.747-1.062-9.038-3.156-12.752-2.098-3.718-5.036-6.669-8.732-8.767M182.884 64.548c-.91-1.018-2.042-1.535-3.364-1.535h-2.895c-1.504 0-2.747-.627-3.799-1.917-1.09-1.335-1.642-3.034-1.642-5.049V36.068h6.207c1.452 0 2.662-.435 3.595-1.294.953-.88 1.437-1.992 1.437-3.306 0-1.427-.484-2.597-1.438-3.478-.933-.858-2.142-1.293-3.594-1.293h-6.207V15.479c0-1.522-.502-2.797-1.493-3.79-.994-.99-2.27-1.492-3.794-1.492-1.525 0-2.801.502-3.793 1.492-.99.989-1.493 2.264-1.493 3.79v11.218h-2.888c-1.454 0-2.663.435-3.592 1.293-.954.88-1.438 2.05-1.438 3.478 0 1.314.483 2.427 1.437 3.306.929.859 2.139 1.294 3.593 1.294h2.888v19.98c0 3.273.698 6.265 2.075 8.895 1.383 2.646 3.325 4.767 5.77 6.305 2.455 1.544 5.203 2.327 8.17 2.327h1.531c1.72 0 3.161-.483 4.285-1.434 1.174-.995 1.769-2.29 1.769-3.847 0-1.499-.447-2.76-1.327-3.746"
                                                fill="#002A8D"
                                            />
                                            <path
                                                d="M225.18 44.472h-25.867c.745-2.99 2.191-5.444 4.304-7.3 2.377-2.086 5.543-3.145 9.41-3.145 3.448 0 6.27 1.046 8.39 3.11 1.906 1.858 3.171 4.324 3.763 7.335m-.295-16.775c-3.331-2.018-7.321-3.042-11.858-3.042-4.588 0-8.758 1.062-12.393 3.157-3.64 2.1-6.521 5.068-8.563 8.82-2.032 3.738-3.062 8.01-3.062 12.696 0 4.699 1.092 8.964 3.246 12.678 2.16 3.723 5.2 6.671 9.04 8.764 3.822 2.087 8.198 3.145 13.008 3.145 2.716 0 5.59-.505 8.544-1.5 2.964-.996 5.485-2.308 7.483-3.894 1.179-.883 1.776-2.018 1.776-3.374 0-1.392-.634-2.625-1.872-3.654-.82-.741-1.911-1.117-3.245-1.117-1.309 0-2.465.387-3.433 1.146-1.098.836-2.532 1.556-4.261 2.14-1.73.585-3.41.882-4.992.882-4.05 0-7.511-1.152-10.288-3.425-2.461-2.011-4.078-4.63-4.811-7.786h31.105c1.406 0 2.592-.454 3.523-1.35.944-.907 1.424-2.058 1.424-3.42 0-4.616-.896-8.775-2.662-12.361-1.782-3.62-4.375-6.482-7.71-8.505M257.938 36.302c2.126-1.284 4.54-1.934 7.172-1.934 2.634 0 5.047.65 7.173 1.934 2.127 1.286 3.82 3.085 5.031 5.346 1.219 2.278 1.837 4.862 1.837 7.68 0 2.82-.617 5.387-1.834 7.633-1.212 2.236-2.905 4.022-5.034 5.307-2.123 1.285-4.537 1.936-7.173 1.936-2.635 0-5.048-.651-7.172-1.936-2.133-1.288-3.843-3.076-5.081-5.316-1.242-2.243-1.872-4.808-1.872-7.624s.63-5.397 1.874-7.672c1.238-2.263 2.947-4.065 5.08-5.354zm19.568-8.401V27.9c-3.692-2.153-7.863-3.245-12.396-3.245-4.53 0-8.727 1.09-12.474 3.241-3.75 2.154-6.728 5.145-8.854 8.89-2.123 3.74-3.2 7.96-3.2 12.542 0 4.572 1 8.782 2.971 12.514 1.98 3.749 4.74 6.73 8.204 8.858 3.469 2.133 7.388 3.215 11.65 3.215 3.433 0 6.678-.72 9.642-2.142a22.013 22.013 0 0 0 5.76-3.99v.51c0 1.527.517 2.816 1.536 3.832 1.02 1.019 2.31 1.535 3.837 1.535 1.526 0 2.816-.516 3.836-1.535 1.019-1.018 1.535-2.307 1.535-3.831V49.328c0-4.583-1.091-8.804-3.244-12.547-2.154-3.74-5.115-6.728-8.803-8.88zM311.974 63.013h-2.129c-.875 0-1.566-.486-2.176-1.531-.697-1.192-1.05-2.763-1.05-4.67V10.376c0-1.525-.503-2.8-1.494-3.79-.993-.99-2.27-1.491-3.793-1.491-1.528 0-2.804.502-3.793 1.491-.992.99-1.494 2.265-1.494 3.79v46.436c0 3.14.574 6.013 1.706 8.542 1.151 2.575 2.806 4.608 4.917 6.044 2.122 1.445 4.537 2.177 7.177 2.177h.17c1.921 0 3.53-.468 4.784-1.391 1.351-.995 2.036-2.304 2.036-3.89 0-1.499-.446-2.76-1.326-3.747-.91-1.017-2.1-1.534-3.535-1.534"
                                                fill="#00C5DC"
                                            />
                                            <g transform="translate(319.03 24.655)">
                                                <mask
                                                    id="67kps8bwld"
                                                    fill="#fff"
                                                >
                                                    <use xlinkHref="#a9lnvb9vtc" />
                                                </mask>
                                                <path
                                                    d="M38.568 24.673c0 2.879-.605 5.478-1.797 7.726-1.179 2.227-2.854 3.994-4.977 5.252-2.127 1.259-4.572 1.897-7.267 1.897-2.694 0-5.138-.638-7.265-1.897-2.126-1.26-3.817-3.03-5.026-5.26-1.216-2.246-1.833-4.843-1.833-7.718 0-2.878.617-5.49 1.835-7.765 1.21-2.258 2.9-4.04 5.024-5.298 2.126-1.26 4.57-1.898 7.265-1.898 2.696 0 5.14.638 7.267 1.898 2.12 1.254 3.793 3.034 4.975 5.29 1.193 2.279 1.799 4.894 1.799 7.773m7.248-12.753c-2.098-3.718-5.036-6.668-8.732-8.767C33.394 1.061 29.169 0 24.527 0c-4.696 0-8.962 1.06-12.68 3.152-3.728 2.1-6.669 5.052-8.739 8.773C1.046 15.635 0 19.924 0 24.673c0 4.692 1.046 8.952 3.108 12.661 2.072 3.724 5.012 6.676 8.74 8.774 3.715 2.09 7.98 3.152 12.68 3.152 4.698 0 8.952-1.061 12.641-3.154 3.695-2.097 6.62-5.048 8.693-8.772 2.063-3.712 3.109-7.971 3.109-12.661 0-4.747-1.062-9.038-3.155-12.753"
                                                    fill="#00C5DC"
                                                    mask="url(#67kps8bwld)"
                                                />
                                            </g>
                                            <g>
                                                <g transform="translate(277 92)">
                                                    <mask
                                                        id="aq8cdzxj1f"
                                                        fill="#fff"
                                                    >
                                                        <use xlinkHref="#hlj0gqg7he" />
                                                    </mask>
                                                    <path
                                                        d="M87.002 0H13.176C8.817 0 5.621 3.327 4.772 7.66 3.924 11.994 0 31.66 0 32.079c0 1.644 1.34 2.977 2.999 2.99H76.823c4.36 0 7.556-3.328 8.405-7.66C86.076 23.073 90 3.407 90 2.99 90 1.345 88.659.01 87 0"
                                                        fill="#002A8D"
                                                        mask="url(#aq8cdzxj1f)"
                                                    />
                                                </g>
                                                <path
                                                    d="M308.416 104.966c.254-.04.856-.077 1.43-.077 1.252 0 2.133.434 2.109 1.438-.031 1.217-1.279 1.908-3.079 1.908h-.7c-.508 0-.358-.576-.358-.576l.598-2.693zm6.069 7.364c0-2.08-1.483-2.987-2.684-3.076 1.517-.25 3.518-1.354 3.518-3.385 0-2.17-2.198-3.328-5.517-3.328-1.508 0-2.974.127-4.283.335l-2.379 10.447s-.822 2.701 1.516 3.263a9.062 9.062 0 0 0 1.83.258c6.204.339 7.999-2.421 7.999-4.514zm-8.098 1.566.783-3.462h1.08c1.533 0 2.804.422 2.77 1.818-.037 1.58-1.67 2.222-3.455 2.222-.28 0-.546 0-.796-.01-.495-.041-.382-.568-.382-.568zM333.928 105.068c.275-.04.747-.07 1.378-.07 1.234 0 2.261.361 2.261 1.832 0 1.494-1.148 2.938-3.383 2.956a7.21 7.21 0 0 1-.404-.01c-1 0-.72-.826-.72-.826l.868-3.882zm-4.272 11.813c.503 0 1.454-.194 1.778-1.628.26-1.14.694-3.078.694-3.078.337.024.803.083 1.35.083 5.315 0 7.164-3.383 7.164-5.682 0-2.508-1.764-3.947-5.606-3.964-1.575-.013-2.936.045-4.227.341l-3.124 13.928h1.971zM319.89 110.728c0-2.267 1.485-5.652 4.887-5.652.89 0 2.485.229 3.404 1.039 0 0 .344-1.152.442-1.632.096-.469-.081-1.25-1.54-1.718-.944-.301-1.683-.447-2.727-.447-5.324 0-8.08 4.333-8.08 8.596 0 4.556 3.077 6.095 6.23 6.095 1.132 0 1.88-.12 2.587-.383.873-.301 1.018-1.078 1.018-1.078l.525-2.342c-1.34.975-2.336 1.126-3.247 1.126-2.21 0-3.5-1.407-3.5-3.604"
                                                    fill="#FFF"
                                                />
                                                <path
                                                    d="M301.281 107.376c.107.143 1.38 1.712.21 3.568-1.285 2.028-4.786 4.343-5.777 4.69-1.927.8-3.232-.682-3.345-.839-.36-.46-.447-.557-.62-.89-.034.054 3.702-1.666 5.039-3.894 1.45-1.913 1.577-5.665-.006-6.371.478.238 1.605.88 2.624 1.777a14.476 14.476 0 0 1 1.875 1.959"
                                                    fill="#FF7800"
                                                />
                                                <path
                                                    d="M297.407 108.908c.825-1.99.69-4.682-.625-5.268-1.204-.56-2.574 1.033-2.639 1.116 0 0-.451.546-.795 1.313.235.126.687.348.687.348a11.261 11.261 0 0 1 3.372 2.49"
                                                    fill="#FFF"
                                                />
                                                <path
                                                    d="M350.162 107.376c.108.143 1.379 1.712.208 3.568-1.283 2.028-4.782 4.343-5.774 4.69-1.928.8-3.234-.682-3.347-.839-.358-.46-.445-.557-.62-.89-.033.054 3.703-1.666 5.04-3.894 1.45-1.913 1.577-5.665-.006-6.371.478.238 1.606.88 2.624 1.777a14.385 14.385 0 0 1 1.875 1.959"
                                                    fill="#FF7800"
                                                />
                                                <path
                                                    d="M346.288 108.908c.823-1.99.691-4.682-.626-5.268-1.203-.56-2.575 1.033-2.637 1.116 0 0-.452.546-.797 1.313.237.126.69.348.69.348.925.442 2.18 1.213 3.37 2.49"
                                                    fill="#FFF"
                                                />
                                            </g>
                                            <g fill="#002A8D">
                                                <path d="M242.32 110.32c.096-.607.18-1.201.18-1.74 0-1.243-.45-2.176-2.241-2.176-.67 0-1.44.11-1.93.325a21.349 21.349 0 0 0-.332 1.65l-.875 5.568a5.55 5.55 0 0 0 1.634.27c2.875 0 3.205-1.658 3.564-3.896zM235.998 121H233l2.137-13.525c.13-.836.282-1.548.475-2.335 1.482-.808 3.392-1.14 5.026-1.14 3.322 0 4.895 1.023 4.895 4.138 0 .635-.063 1.36-.194 2.183-.758 4.766-2.654 6.313-6.356 6.313-.724 0-1.565-.103-2.247-.262l-.738 4.628zM252.178 114.161c1.903 0 2.578-.856 3.054-3.847.124-.788.193-1.423.193-1.941 0-1.43-.538-1.907-1.93-1.907-1.896 0-2.55.774-3.04 3.848-.13.829-.207 1.492-.207 2.017 0 1.423.545 1.83 1.93 1.83m-4.935-1.582c0-.663.068-1.416.206-2.265.724-4.587 2.427-6.314 6.39-6.314 3.234 0 4.592 1.188 4.592 4.09 0 .656-.069 1.388-.2 2.224-.717 4.545-2.426 6.32-6.39 6.32-3.233 0-4.598-1.14-4.598-4.055M259.879 116.468l1.42-8.993c.131-.836.276-1.548.469-2.335 1.482-.808 3.391-1.14 5.025-1.14.428 0 .834.021 1.207.062l-.627 2.46a6.597 6.597 0 0 0-.862-.049c-.703 0-1.544.131-2.062.38a18.352 18.352 0 0 0-.33 1.65l-1.262 7.965h-2.978z" />
                                            </g>
                                        </g>
                                    </svg>
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <div className="p-10">
                    <table className="w-full border-2 border-gray-600">
                        <thead>
                            <tr>
                                <th
                                    className="p-4 uppercase border-2 border-gray-600"
                                    colSpan={2}
                                >
                                    Producto
                                </th>
                                <th
                                    className="p-4 uppercase border-2 border-gray-600"
                                    colSpan={2}
                                >
                                    Subtotal
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={3}
                                >
                                    <div className="flex flex-auto">
                                        <img
                                            src={
                                                `${process.env.REACT_APP_PROXY_ARCHIVOS}/bluecorner/v1/casa/getImagenPrincipal/` +
                                                pedido?.imagen_principal_minificada
                                            }
                                            alt="Imagen attribute"
                                            className="object-cover w-20 h-20 rounded-lg"
                                        />
                                        <div className="ml-3">
                                            <h1 className="font-bold">
                                                {pedido?.casa}
                                            </h1>
                                            Desde{" "}
                                            {pedido?.fecha_inicio.split("T")[0]}
                                            <br />
                                            Hasta{" "}
                                            {pedido?.fecha_final.split("T")[0]}
                                        </div>
                                    </div>
                                </td>

                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={1}
                                >
                                    {pedido.costo_total_alquiler -
                                        pedido.costo_igv}{" "}
                                    {pedido?.tipo_moneda}
                                </td>
                            </tr>
                            {pedido.descuento_puntos > 0 && (
                                <tr>
                                    <td
                                        className="p-4 text-green-600 border-2 border-gray-600"
                                        colSpan={3}
                                    >
                                        Canje Programa Referidos
                                    </td>

                                    <td
                                        className="p-4 text-green-600 border-2 border-gray-600"
                                        colSpan={1}
                                    >
                                        - {pedido.descuento_puntos.toFixed(2)}{" "}
                                        {pedido?.tipo_moneda}
                                    </td>
                                </tr>
                            )}
                            {pedido?.extras.map((extra) => {
                                if (extra.tipo === "-")
                                    return (
                                        <tr
                                            key={extra.id}
                                            className="text-green-500"
                                        >
                                            <td
                                                className="p-4 border-2 border-gray-600"
                                                colSpan={3}
                                            >
                                                {extra.texto}
                                            </td>
                                            <td
                                                className="p-4 border-2 border-gray-600 "
                                                colSpan={1}
                                            >
                                                {extra.tipo} {extra.costo}{" "}
                                                {pedido?.tipo_moneda}
                                            </td>
                                        </tr>
                                    );
                                else return null;
                            })}
                            <tr>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={3}
                                >
                                    Costo de IGV
                                </td>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={1}
                                >
                                    {pedido?.costo_igv.toFixed(2)}{" "}
                                    {pedido?.tipo_moneda}
                                </td>
                            </tr>

                            <tr>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={3}
                                >
                                    Costo de la garantia
                                </td>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={1}
                                >
                                    {pedido?.costo_garantia.toFixed(2)}{" "}
                                    {pedido?.tipo_moneda}
                                </td>
                            </tr>

                            {pedido?.serviciosAdicionales.map((service) => (
                                <tr key={service.id}>
                                    <td
                                        className="p-4 border-2 border-gray-600"
                                        colSpan={2}
                                    >
                                        {service.nombre}
                                    </td>
                                    <td
                                        className="p-4 border-2 border-gray-600 "
                                        colSpan={2}
                                    >
                                        {service.costo_total.toFixed(2)}{" "}
                                        {pedido?.tipo_moneda}
                                    </td>
                                </tr>
                            ))}

                            <tr>
                                <td
                                    colSpan={4}
                                    className="p-4 font-bold text-center uppercase border-2 border-gray-600"
                                >
                                    Resumen
                                </td>
                            </tr>
                            <tr>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={3}
                                >
                                    Costo total:
                                </td>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={1}
                                >
                                    {pedido?.costo_total} {pedido?.tipo_moneda}
                                </td>
                            </tr>
                            <tr>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={3}
                                >
                                    Pagado:
                                </td>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={1}
                                >
                                    {pedido?.pagado.toFixed(2)}{" "}
                                    {pedido?.tipo_moneda}
                                </td>
                            </tr>
                            <tr>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={3}
                                >
                                    Saldo:
                                </td>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={1}
                                >
                                    {pedido?.saldo} {pedido?.tipo_moneda}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="w-full mt-5">
                        <thead>
                            <tr>
                                <th
                                    className="p-4 uppercase border-2 border-gray-600"
                                    colSpan={2}
                                >
                                    Monto a abonar
                                </th>
                                <th
                                    className="p-4 uppercase border-2 border-gray-600"
                                    colSpan={2}
                                >
                                    Subtotal
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={3}
                                >
                                    Monto por alquiler:
                                </td>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={1}
                                >
                                    {pedido.estado === "Pendiente de pago"
                                        ? formaPago === "stripe"
                                            ? pedido.pagos.segundo_pago.monto.toFixed(
                                                  2
                                              )
                                            : pedido.pagos.segundo_pago.monto.toFixed(
                                                  2
                                              )
                                        : null}{" "}
                                    {pedido.estado === "Pago parcial"
                                        ? formaPago === "stripe"
                                            ? pedido.pagos.segundo_pago.monto.toFixed(
                                                  2
                                              )
                                            : pedido.pagos.segundo_pago.monto
                                        : null}{" "}
                                    {pedido?.tipo_moneda}
                                </td>
                            </tr>
                            <tr>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={3}
                                >
                                    Monto por tarjeta:
                                </td>
                                <td
                                    className="p-4 border-2 border-gray-600"
                                    colSpan={1}
                                >
                                    {pedido.estado === "Pendiente de pago"
                                        ? formaPago === "stripe"
                                            ? getPriceCard(
                                                  pedido.pagos.segundo_pago
                                                      .monto
                                              ).toFixed(2)
                                            : 0.0
                                        : null}{" "}
                                    {pedido.estado === "Pago parcial"
                                        ? formaPago === "stripe"
                                            ? getPriceCard(
                                                  pedido.pagos.segundo_pago
                                                      .monto
                                              ).toFixed(2)
                                            : 0.0
                                        : null}{" "}
                                    {pedido?.tipo_moneda}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default PagoCompleto;
